import { useState, type ReactNode } from 'react';
import { Card, Button, Space, Badge } from 'antd';
import { FilterOutlined, DownOutlined, UpOutlined, ClearOutlined } from '@ant-design/icons';

interface FilterPanelProps {
  children: ReactNode;
  activeFilterCount?: number;
  onClearFilters?: () => void;
  defaultCollapsed?: boolean;
}

export function FilterPanel({
  children,
  activeFilterCount = 0,
  onClearFilters,
  defaultCollapsed = false
}: FilterPanelProps) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <Card
      size="small"
      style={{ marginBottom: 16 }}
      styles={{
        body: { padding: collapsed ? 0 : undefined }
      }}
    >
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: collapsed ? '8px 12px' : '0 0 12px 0'
      }}>
        <Space>
          <Badge count={activeFilterCount} size="small" offset={[6, 0]}>
            <Button
              type="text"
              icon={<FilterOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{ fontWeight: 500 }}
            >
              Filtreler {collapsed ? <DownOutlined style={{ fontSize: 10 }} /> : <UpOutlined style={{ fontSize: 10 }} />}
            </Button>
          </Badge>
        </Space>
        {activeFilterCount > 0 && onClearFilters && (
          <Button
            type="text"
            size="small"
            icon={<ClearOutlined />}
            onClick={onClearFilters}
          >
            Temizle
          </Button>
        )}
      </div>
      {!collapsed && (
        <Space wrap>
          {children}
        </Space>
      )}
    </Card>
  );
}
